'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@/shared/components/ui';
import { TriangleAlert } from 'lucide-react';
interface MarcosErroStateProps {
  sugerirSuporte: boolean;
  onTentarNovamente: () => void;
}
export function MarcosErroState(t0) {
  const $ = _c(10);
  const {
    sugerirSuporte,
    onTentarNovamente
  } = t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <TriangleAlert className="text-error-600 h-8 w-8" aria-hidden="true" />;
    t2 = <h4 className="text-body-bold font-body-bold text-default-font">Não foi possível carregar a linha do tempo</h4>;
    t3 = <p className="text-caption text-subtext-color">Ocorreu um erro ao buscar os marcos desta negociação.</p>;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== sugerirSuporte) {
    t4 = sugerirSuporte && <p className="text-caption text-subtext-color">Se o problema persistir, entre em contato com o suporte.</p>;
    $[3] = sugerirSuporte;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== onTentarNovamente) {
    t5 = <Button variant="neutral-secondary" onClick={onTentarNovamente}>Tentar novamente</Button>;
    $[5] = onTentarNovamente;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4 || $[8] !== t5) {
    t6 = <div className="flex w-full flex-col items-center gap-3 py-12 text-center">{t1}{t2}{t3}{t4}{t5}</div>;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}